import { z } from 'zod';

import { SLICE_TAG } from '@/constants';
import {
    ResponseSalesReturnSchema,
    ResponseSalesReturnsSchema,
} from '@/features/slice/sales-return/sales-return.schema';

import { apiSlice } from '../api-slice';

export const salesReturnApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createSalesReturn: builder.mutation({
            query: (data) => ({
                url: 'sales-return',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: [SLICE_TAG.SALES_RETURN],
        }),

        getSalesReturns: builder.query({
            query: (params) => ({
                url: 'sales-return',
                method: 'GET',
                params,
            }),
            providesTags: [SLICE_TAG.SALES_RETURN],
            transformResponse(response) {
                return ResponseSalesReturnsSchema.parse(response);
            },
        }),

        getSalesReturnById: builder.query<
            z.infer<typeof ResponseSalesReturnSchema>,
            string
        >({
            query: (id) => ({
                url: `sales-return/${id}`,
                method: 'GET',
            }),
            providesTags: (_result, _error, id) => [
                { type: SLICE_TAG.SALES_RETURN, id },
            ],
            transformResponse(response) {
                return ResponseSalesReturnSchema.parse(response);
            },
        }),
    }),
});

export const {
    useCreateSalesReturnMutation,
    useGetSalesReturnsQuery,
    useLazyGetSalesReturnsQuery,
    useGetSalesReturnByIdQuery,
    useLazyGetSalesReturnByIdQuery,
} = salesReturnApiSlice;
